import ConfirmModalV2 from '../ConfirmModalV2'
import { ReactComponent as SignalStrength } from '../../assets/icons/signal-strength.svg'
import { ReactComponent as SignalStrengthMobile } from '../../assets/icons/signal-strength.svg'
import useGetIsMobileScreen from '../../hooks/useGetIsMobileScreen'
import { APPLICATION_STRINGS } from '../../strings'

const ConnectionRequiredModal = ({ onButtonClick, subtext = null }) => {
  const isMobileViewPort = useGetIsMobileScreen()

  return (
    <ConfirmModalV2
      headerText={''}
      icon={isMobileViewPort ? <SignalStrengthMobile /> : <SignalStrength />}
      onButtonTwoClick={onButtonClick}
      subtext={subtext ? subtext : APPLICATION_STRINGS.INTERNET_CONNECTION_REQUIRED}
      singleButtonOnly={true}
      buttonTwoText={'OKAY'}
    />
  )
}

export default ConnectionRequiredModal
